export default "__VITE_ASSET__DIu1Sp$B__"